import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Keep the document language in sync with the selected UI language for
 * screen readers and browser translation on both public and private pages.
 */
export function useDocumentLanguage(): void {
  const { i18n } = useTranslation();
  const language = i18n.language;

  useEffect(() => {
    if (language) document.documentElement.lang = language;
  }, [language]);
}
